// React
import { useEffect, type ReactNode } from 'react';

// Misc
import { initPostHog } from '../../lib/posthog';

type PostHogProviderProps = {
  children: ReactNode;
};

export const PostHogProvider = ({ children }: PostHogProviderProps) => {
  useEffect(() => {
    initPostHog();
  }, []);

  return <>{children}</>;
};
